import React, { useEffect } from 'react';

import { Card, Large, ContentSubtitle, Button } from 'components';
import PropTypes from 'prop-types';
import { clearUserInfoFields } from 'redux/slices/signUp/signUpSlice';
import { useDispatch } from 'react-redux';

const PreSignUp = ({ onPrev, onNavigate }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearUserInfoFields());
  }, []);

  const cardContent = [
    {
      icon: <i className="fa-solid fa-circle-user text-white" />,
      title: 'Şahıs Hesabı Oluştur',
      onClick: () => {
        onNavigate('şahıs');
      },
    },
    {
      icon: <i className="fa-solid fa-briefcase text-white" />,
      title: 'İşletme Hesabı Oluştur',
      onClick: () => {
        onNavigate('işletme');
      },
    },
  ];

  return (
    <div
      className={`flex flex-col h-70vh w-full ${onPrev ? 'py-2' : ''} w-full `}
    >
      <div className="flex bg-white flex-col items-center justify-center w-full h-full ">
        <div className="flex flex-row w-full p-6 h-auto items-center  text-center gap-x-4">
          {cardContent.map((item, index) => (
            <Card
              key={index}
              className="bg-primary border-white h-20 cursor-pointer items-center justify-center text-center space-y-2"
              onClick={item.onClick}
            >
              {item.icon}
              <Large variant="white" weight="semibold">
                {item.title}
              </Large>
            </Card>
          ))}
        </div>
        <ContentSubtitle className="mx-auto">
          Şahıs veya İşletme olarak kolayca kayıt olabilirsiniz.
        </ContentSubtitle>
      </div>
      {onPrev && (
        <Button
          text="Geri"
          className="bg-ink p-3 mx-auto w-1/3"
          textVariant="white"
          onClick={onPrev}
        />
      )}
    </div>
  );
};

PreSignUp.propTypes = {
  onPrev: PropTypes.func,
  onNavigate: PropTypes.func,
};
export default PreSignUp;
